// extracted by mini-css-extract-plugin
export default {"section":"section__1R5Aw"};